<template>
    <v-container class="fill-height">
        <v-responsive class="d-flex align-center text-center fill-height">
            <img 
            v-bind:src="require('../assets/err404.png')" 
            :width="width" 
            />
            <v-row class="d-flex align-center justify-center">
                
                <v-col cols="auto">
                    {{ $vuetify.lang.translator("not_found_component.description") }}
                </v-col>
            </v-row>
            <v-row class="d-flex align-center justify-center">
                
                <v-col cols="auto">
                    
                    <v-btn
                        href="/"
                        min-width="164"
                        class="ma-2"
                  outlined
                  color="grey"
                    >
                    <v-icon>mdi-home</v-icon>

                        {{ $vuetify.lang.translator("not_found_component.go_home") }}
                        
                    </v-btn>
                </v-col>
            </v-row>
            
        </v-responsive>
    </v-container>
</template>

<script>
export default {
    name: "PageNotFound",
    components: { },
    metaInfo: {
        title: "Page not found",
        titleTemplate: "%s | iLook.su",
    },
  data() {
    return {
        width: this.getDefaultWidth(),
    };
  },
  methods: {
    getDefaultWidth(){
      return document.documentElement.clientWidth / 1.3 > 400 ? 400 : document.documentElement.clientWidth / 1.3
    },
    getDimensions() {
      this.width = this.getDefaultWidth();
      this.height = document.documentElement.clientHeight;
    },
  },
  mounted(){
    window.addEventListener('resize', this.getDimensions);
  },
  unmounted() {
    window.removeEventListener('resize', this.getDimensions);
  },
};
</script>